import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createOverviewLabel: {
		id: 'spa-apps-sidebar-core.multi-project-menu.overviews.create-overview.create-overview-label',
		defaultMessage: 'Create overview',
		description: 'Label for the create overview button.',
	},
});
